export default "__VITE_ASSET__B$K3xTDo__"